import { lazy } from 'react';
import Loadable from 'components/Loadable';

const AssetDashboard = Loadable(lazy(() => import('./components/asset-dashboard/AssetDashboard')));
const AssetsList = Loadable(lazy(() => import('./components/assets-list/AssetsList')));
const AssetsByCategory = Loadable(lazy(() => import('./components/assets-by-category/AssetsByCategory')));
const AssetAssignments = Loadable(lazy(() => import('./components/asset-assignments/AssetAssignments')));
const AssetRequests = Loadable(lazy(() => import('./components/asset-requests/AssetRequests')));
const AssetMaintenance = Loadable(lazy(() => import('./components/asset-maintenance/AssetMaintenance')));
const AssetStock = Loadable(lazy(() => import('./components/asset-stock/AssetStock')));
const AssetDepreciation = Loadable(lazy(() => import('./components/asset-depreciation/AssetDepreciation')));
const AssetReports = Loadable(lazy(() => import('./components/asset-reports/AssetReports')));
const AssetSettings = Loadable(lazy(() => import('./components/asset-settings/AssetSettings')));
const AssetProcurement = Loadable(lazy(() => import('./components/asset-procurement/AssetProcurement')));

export const assetRoutes = {
  path: 'assets',
  children: [
    { index: true, element: <AssetDashboard /> },
    { path: 'dashboard', element: <AssetDashboard /> },
    { path: 'list', element: <AssetsList /> },
    { path: 'list/:categoryId/:categoryName', element: <AssetsByCategory /> },
    { path: 'assignments', element: <AssetAssignments /> },
    { path: 'requests', element: <AssetRequests /> },
    { path: 'maintenance', element: <AssetMaintenance /> },
    { path: 'stock', element: <AssetStock /> },
    { path: 'depreciation', element: <AssetDepreciation /> },
    { path: 'procurement', element: <AssetProcurement /> },
    { path: 'procurement/new', element: <AssetProcurement /> },
    { path: 'procurement/edit/:id', element: <AssetProcurement /> },
    { path: 'purchases', element: <AssetProcurement /> },
    { path: 'vendors', element: <AssetProcurement /> },
    { path: 'reports', element: <AssetReports /> },
    { path: 'settings', element: <AssetSettings /> }
  ]
};

export default assetRoutes;
